// extracted by mini-css-extract-plugin
export default {"label":"range_label__ESrwN","target":"range_target__Tgc7M"};